import type { IFilterFormData } from '@/Interfaces/PdfBuilder/FilterFormData.interface';
import type {
  IPdfCustomReportTemplate,
  IPdfCustomReportTemplateListItem,
} from '@/Interfaces/PdfBuilder/Template.interface';
import {
  PDF_CUSTOM_REPORT_TEMPLATES_ENDPOINT,
  pdfCustomReportTemplateEndpoint,
  pdfCustomReportTemplateShareEndpoint,
} from '@/constants/endpoints';
import { getPdfTemplatePayload } from '@/helpers/pdfBuilder';
import axios from 'axios';

export const fetchPdfTemplates = async (signal?: AbortSignal): Promise<IPdfCustomReportTemplateListItem[]> => {
  const response = await axios.get(PDF_CUSTOM_REPORT_TEMPLATES_ENDPOINT, { signal });
  return response.data;
};

export const fetchPdfTemplate = async (id: number, signal?: AbortSignal): Promise<IPdfCustomReportTemplate> => {
  const response = await axios.get(pdfCustomReportTemplateEndpoint(id), { signal });
  return response.data;
};

export const createPdfTemplate = async (templateName: string, formData: IFilterFormData) => {
  const response = await axios.post(
    PDF_CUSTOM_REPORT_TEMPLATES_ENDPOINT,
    getPdfTemplatePayload(formData, templateName),
  );
  return response.data ?? {};
};

export const deletePdfTemplate = async (id: number) => {
  return await axios.delete(pdfCustomReportTemplateEndpoint(id));
};

export const sharePdfTemplate = async (id: number, payload: { receivingUserIds: number[]; shareWithOrg: boolean }) => {
  const response = await axios.post(pdfCustomReportTemplateShareEndpoint(id), payload);
  return response.data;
};
